var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L12.2426 13.1716L15.7782 16.7071C16.1687 17.0976 16.8019 17.0976 17.1924 16.7071C17.5829 16.3166 17.5829 15.6834 17.1924 15.2929L13.6569 11.7574L17.1924 8.22183C17.5829 7.8313 17.5829 7.19814 17.1924 6.80761C16.8019 6.41709 16.1687 6.41709 15.7782 6.80761L12.2426 10.3431L8.70711 6.80761C8.31658 6.41709 7.68342 6.41709 7.29289 6.80761C6.90237 7.19814 6.90237 7.8313 7.29289 8.22183L10.8284 11.7574L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071Z",
    fill: "#bababa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseGray);
export default __webpack_public_path__ + "static/media/ic_close_gray.9f86585e4545496cba97bf95e92da0a7.svg";
export { ForwardRef as ReactComponent };